import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SearchIcon } from "./svgIcons";
import { Popover, PopoverTrigger, PopoverContent, Button, Input, Divider } from "@heroui/react";


const BreadcrumbSearch = ({ allowedRoutes }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  // Filter routes based on search input
  const filterRoutes = (routes, term) => {
    if (!term) return routes;
    return routes
      .map((route) => {
        const lowerTerm = term.toLowerCase();
        const parentMatches = route.name.toLowerCase().includes(lowerTerm);
        let filteredChildren = [];
        if (route.children && route.children.length > 0) {
          filteredChildren = route.children.filter((child) =>
            child.name.toLowerCase().includes(lowerTerm)
          );
        }
        if (parentMatches || filteredChildren.length > 0) {
          return {
            ...route,
            // If parent's not matching, use only filtered children
            children: parentMatches ? route.children : filteredChildren,
          };
        }
        return null;
      })
      .filter((r) => r !== null);
  };
  const filteredRoutes = filterRoutes(allowedRoutes, searchTerm);

  return (
    <div className="relative w-52">
      {/* Search Bar (Dropdown Trigger) */}

      <Popover  key='bottom-start' placement='bottom-start'>
        <PopoverTrigger>
          <Button className="w-full flex justify-start text-right border border-solid rounded-3xl border-gray-100" color="#fff" startContent={<SearchIcon />} >
            Type to search...
          </Button>
        </PopoverTrigger>
        <PopoverContent className="bg-white w-[350px] p-0 ">
          <div className="px-5 py-5 w-full flex justify-center items-center gap-4">
            <Input
              classNames={{
                base: "max-w-full  h-10",
                mainWrapper: "h-full ",
                input: "text-small",
                inputWrapper:
                  "h-full font-normal  text-default-500 border-solid rounded-3xl border-gray-300 px-4",
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search here..."
              size="sm"
              type="search"
            />
            {/* <CloseIcon onClick={() => { setSearchTerm(""); setIsOpen(false); }} /> */}
          </div>
          <Divider />
          <div className="w-full px-5 py-5 flex justify-start items-start flex-col h-[350px] overflow-auto default-scrollbar">
            <h4 className="text-xl font-semibold pb-3 px-2">Quick Page Links</h4>
            {filteredRoutes.length > 0 ? (
              filteredRoutes.map((route, index) => (
                <div key={route.path || `route-${index}`} className="flex flex-col">

                  <div className="hover:bg-custom-bg w-full py-2 px-2 cursor-pointer flex flex-col"
                    onClick={() => {
                      navigate(route.url);
                    }}
                  >
                    <span className="text-medium font-light">{route.name}</span>
                    <span className="text-gray-500 text-xs">{route.url}</span>
                  </div>

                  {/* Child routes, if any */}
                  {route.children && route.children.length > 0 && (
                    <div className="ml-4 border-l border-gray-100 pl-4">
                      {route.children.map((child, childIndex) => (
                        <div
                        key={child.url || `child-route-${childIndex}`}
                          className="hover:bg-custom-bg w-full py-2 px-2 cursor-pointer flex flex-col"
                          onClick={() => {
                            navigate(child.url);
                          }}
                        >
                          <span className="text-medium font-light">{child.name}</span>
                          <span className="text-gray-500 text-xs">{child.url}</span>
                        </div>
                      ))}
                    </div>
                  )}

                </div>

              ))
            ) : (
              <div className="p-2 text-gray-500">No matches found</div>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default BreadcrumbSearch;
